<template>
  <div>
    <div
      :class="{ 'product--unavailable': unavailable }"
      :style="{
        height: layoutBreakpoint.isMobile ? '116px' : '62px',
      }"
    >
      <el-row style="height: 62px">
        <!-- remove button -->
        <el-col
          v-if="!layoutBreakpoint.isMobile"
          :span="1"
          :class="['product__cell text-left', isReserved ? 'ml-4' : '']"
          style="background-color: #fff"
        >
          <el-image
            class="mt-22 remove-cart-product"
            style="
              height: 14px;
              width: 14px;
              cursor: pointer;
              font-size: 18px;
              color: #cecece;
            "
            :src="images.shoppingCartRemove.src"
            :fit="'contain'"
            @click="emitRemove"
          />
        </el-col>

        <!-- product image -->
        <el-col
          :span="3"
          :class="[
            'rectangle product__cell',
            isReserved
              ? layoutBreakpoint.isTablet
                ? 'ml-6'
                : 'ml-2'
              : layoutBreakpoint.isMobile
              ? 'ml-2'
              : layoutBreakpoint.isTablet
              ? 'ml-12'
              : 'ml-8',
          ]"
        >
          <el-image
            class="pb-2"
            style="height: 56px; width: 56px"
            :src="thumbnail"
            :fit="'contain'"
          />
        </el-col>

        <!-- product detail -->
        <el-col
          :span="
            layoutBreakpoint.isMobile
              ? 20
              : layoutBreakpoint.isTablet
              ? isReserved
                ? 9
                : 10
              : 11
          "
          :class="[
            'product__detail product__cell',
            layoutBreakpoint.isTablet ? '' : 'pl-4',
          ]"
        >
          <h5 class="product--name">
            {{ productName }}
          </h5>
          <div class="product-cart">
            {{ provider }}
          </div>
          <div class="product-cart">
            {{ origin }}
          </div>
        </el-col>

        <!-- remove button -->
        <el-col
          v-if="layoutBreakpoint.isMobile"
          :span="3"
          class="product__cell text-left ml-2"
        >
          <el-image
            class="mt-30 remove-cart-product"
            style="
              height: 14px;
              width: 14px;
              cursor: pointer;
              font-size: 18px;
              color: #cecece;
            "
            :src="images.shoppingCartRemove.src"
            :fit="'contain'"
            @click="emitRemove"
          />
        </el-col>

        <!-- product qty -->
        <el-col
          :span="layoutBreakpoint.isMobile ? 8 : 6"
          :class="[
            'product__cell text-left',
            layoutBreakpoint.isTablet
              ? isReserved
                ? 'pl-17'
                : 'pl-3'
              : isReserved
              ? 'pl-6'
              : 'pl-16',
          ]"
        >
          <div v-if="unavailable" class="unavailable-badge">
            <div class="unavailable-badge__label">
              {{ $i18n.t("shoppingCart.shoppingCartView.unavailableLabel") }}
            </div>
            <div class="unavailable-badge__hint">
              {{ $i18n.t("shoppingCart.shoppingCartView.unavailableHint") }}
            </div>
          </div>
          <div
            v-if="!unavailable"
            :class="[
              'highlight highlight__label ml-2',
              layoutBreakpoint.isMobile ? 'mt-8' : 'mt-18',
            ]"
          >
            {{ $i18n.t("products.productCardComponent.quantity") }}
          </div>
          <div v-if="!unavailable" class="flex">
            <el-form
              ref="quantityForm"
              :model="quantityForm"
              style="line-height: 24px"
              @submit.native.prevent
            >
              <el-form-item
                prop="quantity"
                :rules="[
                  {
                    required: true,
                    message: 'quantity is required',
                    trigger: 'blur',
                  },
                  {
                    type: 'number',
                    message: 'quantity must be a number',
                    trigger: 'blur',
                  },
                ]"
                style="width: 40px"
              >
                <el-input
                  ref="qtyInput"
                  class="product-qty"
                  v-model.number="quantityForm.quantity"
                  :placeholder="''"
                  @keyup.native="emitQuantityChange"
                />
              </el-form-item>
            </el-form>
            <div
              class="label highlight__label text-left ml-7 mt-4"
              style="font-size: 12px"
            >
              {{ caisse }}
            </div>
          </div>
        </el-col>

        <!-- product price -->
        <el-col
          :span="
            layoutBreakpoint.isMobile
              ? 12
              : layoutBreakpoint.isTablet && isReserved
              ? 4
              : 3
          "
          :class="[
            'product__cell text-left',
            layoutBreakpoint.isMobile ? 'ml-10' : isReserved ? 'ml-0' : 'ml-20',
          ]"
        >
          <div
            :class="[
              'subtitle1 pt-42 text-right',
              layoutBreakpoint.isTablet
                ? isReserved
                  ? 'pr-12'
                  : 'pr-1'
                : layoutBreakpoint.isMobile && isReserved
                ? 'pr-14'
                : 'pr-5',
            ]"
          >
            <!-- {{ price }}  -->
            {{ productPrice }}
          </div>
        </el-col>
      </el-row>
    </div>

    <el-divider
      v-if="layoutBreakpoint.isMobile && isReserved"
      class="divider divider__mobile__reserved"
    />
    <el-divider
      v-else-if="layoutBreakpoint.isMobile"
      class="divider divider__mobile"
    />
    <el-divider
      v-else-if="layoutBreakpoint.isTablet && isReserved"
      class="divider divider__tablet__reserved"
    />
    <el-divider
      v-else-if="layoutBreakpoint.isTablet"
      class="divider divider__tablet"
    />
    <el-divider v-else-if="isReserved" class="divider divider__reserved" />
    <el-divider v-else class="divider" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { get, head } from "@/utils/lodash";
import { formatCurrency } from "@/utils/common-utils";
import layoutUtils from "@/utils/layout-utils";

import imgShoppingCartRemove from "@/assets/images/shopping-cart/shopping-cart-remove-item.png";
import imgProductDefault from "@/assets/images/product/product-default.png";

export default {
  props: {
    isReserved: {
      type: Boolean,
      default: false,
    },
    available: {
      type: Number,
      default: 0,
    },
    unavailable: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      default: () => {},
    },
    qty: {
      type: Number,
      default: 0,
    },
    productType: {
      type: String,
      default: "",
    },
    ProductDefaultPrice: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      quantityForm: {
        quantity: this.qty,
      },
      images: {
        shoppingCartRemove: {
          src: imgShoppingCartRemove,
        },
        productDefault: {
          src: imgProductDefault,
        },
      },
    };
  },
  computed: {
    ...mapGetters("user", ["isLoggedIn"]),
    ...mapState("configuration", ["actionBar"]),

    origin() {
      const originHead = head(get(this.product, "origins"));
      const country = get(originHead, "country.name");
      const region = get(originHead, "region.name");

      return originHead && `${country}, ${region == null ? "" : region}`;
    },
    productName() {
      return get(this.product, "name");
    },
    provider() {
      const aliasName = get(this.product, "cmsProvider.aliasName");

      if (aliasName == null) {
        return get(this.product, "provider.usualName");
      }
      return aliasName;
    },
    productPrice() {
      const uvc = get(this.product, "uvc", 1); // Default to 1 if missing
      if (!Array.isArray(this.ProductDefaultPrice) || this.ProductDefaultPrice.length === 0) {
        console.error("Invalid ProductDefaultPrice structure");
        return null;
      }

      // Find the correct product entry by productId
      const priceEntry = this.ProductDefaultPrice.find(price => price.productId === this.product.id);

      // if (!priceEntry) {
      //   console.warn(`No price found for product ID: ${this.product.id}`);
      //   return null;
      // }

      if (this.actionBar &&  this.actionBar.tax === "IN") {
        const price = Number(priceEntry?.productPrice ?? 0);
        const fees = Number(priceEntry?.agencyFees ?? 0);
        let totalPrice = 0;
        if(price > 0 && fees > 0){
          totalPrice = (price + fees);
        }else{
          totalPrice = (get(this.product, "priceTaxIn", price + fees)) * uvc;
        }
        return formatCurrency(totalPrice, this.$i18n.locale);
      }
      return formatCurrency(get(this.product, "price", priceEntry?.productPrice) * uvc);
    },

    price() {
      let price = get(this.product, "pricing.price", 0);
      const uvc = get(this.product, "uvc", 0);
      // let agencyFees = get(this.product, "pricing.agencyFee", 0);

      // if (this.actionBar &&  this.actionBar.tax === "IN") {
      //   price = get(this.product, "pricing.priceTaxIn", 0);
        // agencyFees = get(this.product, "pricing.agencyFeeWTaxes", 0);
      // }
      // let uvc = get(this.product, "uvc", 0);
      // if(this.productType == 'boutique'){
      //   uvc = 1;
      // }
      const total = (price * this.quantityForm.quantity);
      if(this.productType == 'boutique'){
        return formatCurrency(total, this.$i18n.locale);
      }
      const totalWithUVC = total * uvc; 
      return formatCurrency(totalWithUVC, this.$i18n.locale);
    },
    thumbnail() {
      const thumbnail = get(this.product, "image.thumbnailLink");

      if (thumbnail == null) {
        return this.images.productDefault.src;
      }

      return thumbnail;
    },
    caisse() {
      const uvc = get(this.product, "uvc", 0);
      if(this.productType == 'boutique'){
        return '';
      }
      return this.$i18n.t("products.productCardComponent.boxOf", {
        numberOfBottle: uvc,
      });
    },
    layoutBreakpoint() {
      return layoutUtils.layoutBreakpoint(this.$mq);
    },
  },
  mounted() {
    this.quantityForm.quantity = this.qty;

    // The quantity input is not rendered for unavailable products.
    if (!this.$refs.qtyInput) {
      return;
    }
    // to address conditional style changes to element-ui components
    this.$refs.qtyInput.$el.children[0].style.cssText =
      "height:24px !important; width: 40px; margin: 0 !important; padding: 0 3px !important; text-align: center !important;";
    this.$refs.qtyInput.$el.style.display = "block";
  },
  watch: {
    qty(newQty) {
      this.quantityForm.quantity = newQty;
    },
  },
  methods: {
    emitRemove() {
      this.$emit("emit-remove", this.product.puid);
    },
    emitQuantityChange() {
      this.$refs.quantityForm
        .validate()
        .then(() => {
          this.$emit("emit-quantity-change", {
            puid: this.product.puid,
            quantity: this.productType == 'boutique' ? this.quantityForm.quantity : this.quantityForm.quantity *  get(this.product, "uvc", 0),
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.rectangle {
  width: 61px;
  height: 61px;
  background-color: rgba(237, 240, 237, 0.33);
  box-sizing: border-box;
}
.product__detail {
  & div {
    background-color: rgba(255, 255, 255, 0);
    color: #272421B2;
    box-sizing: border-box;
    text-align: left;
    line-height: normal;
    height: 20px;
    padding: 2px 2px 2px 2px;
  }
}
.product--name {
  color: #333333 !important;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 400;

  // sm -
  @media screen and (max-width: $media-md) {
    font-size: 16px !important;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    font-size: 18px !important;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    font-size: 18px !important;
  }
}

.el-form-item__content {
  line-height: 24px;
}

.el-input {
  line-height: 24px;
}

.highlight__label {
  line-height: 18px;
  color: rgba(39, 36, 33, 0.33);
}
.price {
  width: 58px;
  height: 26px;
  padding: 2px 2px 2px 2px;
  background-color: $color-on-primary;
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 500;
  color: #272421;
  text-align: left;
  line-height: normal;
  letter-spacing: 0.15px;
}
.divider {
  margin: 18px 0 10px 0;
  background-color: #DCDCDC;
}
.divider__mobile {
  margin-bottom: 20px !important;
}
.product__cell {
  height: 100%;
}
.product-cart {
  font-size: 14px;
  // font-weight: 300;
}

// Unavailable (no longer published) products: dim everything except the remove
// button so it is obvious the line must be removed before checkout.
.product--unavailable {
  // Let the row grow to fit the "Indisponible" badge instead of being clipped
  // by the fixed card height — otherwise the badge overflows and overlaps the
  // next product on mobile.
  height: auto !important;

  .el-row {
    height: auto !important;
    min-height: 62px;
  }

  .rectangle,
  .product--name,
  .product-cart,
  .subtitle1 {
    opacity: 0.4;
  }
}
.unavailable-badge {
  // Sits where the quantity selector is, near the top of the qty/price line.
  margin-top: 8px;
}
.unavailable-badge__label {
  color: #a31c25;
  font-weight: bold;
  font-size: 13px;
  line-height: 16px;
}
.unavailable-badge__hint {
  color: #a31c25;
  font-size: 11px;
  line-height: 14px;
}

@media screen and (max-width: $media-md) {
  .unavailable-badge {
    margin-top: 8px;
  }
  .unavailable-badge__label {
    font-size: 12px;
    line-height: 14px;
  }
  .unavailable-badge__hint {
    font-size: 10px;
    line-height: 12px;
  }
}
</style>
